import {useForm} from "@inertiajs/react";
import axios, {AxiosError} from "axios";
import {useState} from "react";



interface PostOptions {
  extraData?: object
}

export default function useAjaxForm<TForm extends object>(initialValues?: TForm) {

  // @ts-ignore
  const { data, setData, errors, setError, clearErrors, reset} = useForm<TForm>(initialValues ?? {})
  // const { data, setData, errors, setError, clearErrors, reset} = useForm<TForm>(initialValues ?? null)
  // const {data, setData } = useForm<any>(false);

  const [processing, setProcessing] = useState(false);
  const [success, setSuccess] = useState(false);

  const post = async (url: string, options: PostOptions): Promise<boolean> => {

    try {
      clearErrors()
      setProcessing(true)

      const finalData = (options.extraData) ? {...data, ...options.extraData} : data;
      const response = await axios.post(url, finalData)

      setSuccess(true)
      reset();
      return true;
    } catch (err) {

      const errors = err as Error | AxiosError;
      if (axios.isAxiosError(errors)) {
        const {data, status} = errors.response || {}
        setError(data.errors)
      }
      return false;
    } finally {
      setProcessing(false)
    }
  }

  return {
    data, setData, errors, setError, clearErrors, reset, post, processing, success, setSuccess
  }
}
